import { PlanCargoService } from './../../../_services/plan-cargo.service';
import { NavService } from './../../../_services/_nav.service';
import { PlanCargo } from './../../../_models/plan-cargo';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-planes-cargos-editar',
  templateUrl: './planes-cargos-editar.component.html',
  styleUrls: ['./planes-cargos-editar.component.css'],
})
export class PlanesCargosEditarComponent implements OnInit {
  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  planCargo: PlanCargo;
  lisPlanesCargos: PlanCargo[] = [];
  tabSeleccionado = 'INFO';
  formulario: FormGroup;
  submitted = false;

  constructor(
    private nav: NavService,
    private planCargoService: PlanCargoService,
    private location: Location,
    private conServicio: ConfirmationService,
    private route: ActivatedRoute,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      if (params['id'] !== '' && params['id'] !== null && params['id'] !== undefined) {
        this.planCargoService
          .obtenerPorId(params['id'])
          .subscribe((planCargo) => {
            this.planCargo = planCargo;
            this.cargarFormulario();
          });
      } else {
        this.cargarFormulario();
      }
    });
  }

  cargarFormulario() {
    this.formulario = this.fb.group({
      idPlanCargo: [this.planCargo ? this.planCargo.idPlanCargo : null],
      codigo: [
        this.planCargo ? this.planCargo.codigo : null,
        [Validators.required, Validators.maxLength(10)],
      ],
      nombre: [
        this.planCargo ? this.planCargo.nombre : null,
        [Validators.required, Validators.maxLength(100)],
      ],
      descripcion: [this.planCargo ? this.planCargo.descripcion : null],
    });

    this.planCargoService.listado().subscribe((planesCargos) => {
      this.lisPlanesCargos = planesCargos;
      this.carInformacionInicial = false;
    });
  }

  onSubmit() {
    this.submitted = true;
    const planCargo = this.formulario.value;
    this.guardando = true;
    if (this.formulario.valid && !this.codExiste) {
      this.guardarPlanCargo(planCargo);
    } else {
      this.guardando = false;
    }
  }


  guardarPlanCargo( planCargo: PlanCargo) {
    if ( planCargo.idPlanCargo !== '' && planCargo.idPlanCargo !== null && planCargo.idPlanCargo !== undefined) {
      this.planCargoService.actualizar( planCargo ).subscribe( rta => {
        this.nav .setMesage(1);
        this.planCargo = planCargo;
        this.guardando = false;
      }, error => {
        this.nav.setMesage( 3 );
        this.guardando = false;
      } );
    } else {
      this.planCargoService.crear( planCargo ).subscribe( rta => {
        this.nav.setMesage(1);
        this.planCargo = planCargo;
        this.planCargo.idPlanCargo = rta.idPlanCargo;
        this.f.idPlanCargo.setValue( rta.idPlanCargo );
        this.guardando = false;
      }, error => {
        this.nav.setMesage( 3 );
        this.guardando = false;
      } );
    }
  }

  abrirAcordeon(evento: any) {
    switch (evento.index) {
      case 0: {
        this.tabSeleccionado = 'INFO';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'CONCEP';
        break;
      }
      default: {
        break;
      }
    }
  }

  validarCodigo() {
    this.codExiste = this.lisPlanesCargos.find(
      (x) =>
        x.codigo === this.f.codigo.value &&
        (!this.planCargo || this.planCargo.idPlanCargo !== x.idPlanCargo)
    )
      ? true
      : false;
  }

  get f() {
    return this.formulario.controls;
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.nav.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.nav.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }

  cambiarTabSeleccionado( tab: string ) {
    this.tabSeleccionado = tab;
  }
}
